module.exports = __webpack_public_path__ + "assets/img/theme_iris_large.bab69e23.png";